import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Map, TileLayer } from 'react-leaflet'

import CharacterDropIn from '../components/CharacterDropIn'
import SwappableDiv from '../components/SwappableDiv'

import { swapDiv } from '../actions/actions'

class Graphistry extends Component {
    constructor(props) {
        super(props)
        this.DEFAULT_VIEWPORT = {
            center: [38.303065, -77.458153],
            zoom: 15,
        }
        this.state = {
            viewport: this.DEFAULT_VIEWPORT,
            showDiv: false,
        }
    }

    swapdiv = () => {
        this.props.dispatch( swapDiv() )
    }

    render() {
        return(
            <div>
                <nav className="pt-navbar">
                    <div className="pt-navbar-group pt-align-left">
                        <div className="pt-navbar-heading">
                            <b><CharacterDropIn value={'Jamal Mahboob: Graphistry Test'} /></b>
                        </div>
                    </div>
                    <div className="pt-navbar-group pt-align-right">
                        <div className="pt-navbar-heading pt-button-group">
                            <button className="pt-button" onClick={() => this.setState({ showDiv: !this.state.showDiv })}>
                                {this.state.showDiv ? "Hide Text" : "Show Text"}
                            </button>
                            <button className="pt-button" onClick={this.swapdiv}>
                                Swap Div
                            </button>
                        </div>
                    </div>
                </nav>

                { this.state.showDiv && <SwappableDiv /> }

                <div className="graphistry_left">
                    <Map style={{width: '100%'}} className="mapContainer" position={this.position} viewport={this.state.viewport}>
                        <TileLayer
                            url="https://api.mapbox.com/styles/v1/jamalmahboob/cjbuxjgpwbyun2rskns8dt6jh/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamFtYWxtYWhib29iIiwiYSI6ImNpeTIweGxuYTAwMDkycWxhaDN1YmZndWYifQ.ZqVbtaAFaZvyQxq030_csQ"
                        />
                    </Map>
                </div>
                <div className="graphistry_right">
                    <iframe frameBorder={0} style={{width: '100%', height: '100%'}} src="https://labs.graphistry.com/graph/graph.html?dataset=Facebook" />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps)(Graphistry)



// WEBPACK FOOTER //
// ./src/containers/Graphistry.js